const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizeEmailAddress(rawEmail: string): string {
  const trimmedEmail = rawEmail.trim();
  const atIndex = trimmedEmail.lastIndexOf('@');
  if (atIndex <= 0) return trimmedEmail;

  const localPart = trimmedEmail.slice(0, atIndex).trim();
  const domain = trimmedEmail
    .slice(atIndex + 1)
    .trim()
    .replace(/^@+/, '')
    .replace(/\.+$/, '')
    .toLowerCase();

  if (!localPart || !domain) return trimmedEmail;
  return `${localPart}@${domain}`;
}

export function isValidEmailAddress(email: string): boolean {
  return EMAIL_PATTERN.test(email);
}
